import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import MovingImages from "../../../components/MovingImages/MovingImages"
import Button from "../../../components/button/button"
import * as styles from "./index.module.css"
import { navigate } from "gatsby"
import RegistrationForm from "../../../components/CustomDialogs/RegistrationForm"
import BodyText from "../../../components/text/body-text/body-text"

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const EmployersSection = () => {
  const [isRegistrationFormOpen, setIsRegistrationFormOpen] = useState(false)
  const employersImages = {
    left: [
      <StaticImage
        key="emp-first-1"
        src="../../../images/index/employers/home/taj.png"
        alt="Taj"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-2"
        src="../../../images/index/employers/home/hyatt.png"
        alt="Hyatt"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-3"
        src="../../../images/index/employers/home/marriott.png"
        alt="Merriott"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-4"
        src="../../../images/index/employers/home/itc.png"
        alt="ITC Hotels"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-5"
        src="../../../images/index/employers/home/max.png"
        alt="Max Healthcare"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-6"
        src="../../../images/index/employers/home/fortis.png"
        alt="Fortis"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-7"
        src="../../../images/index/employers/home/ihg.png"
        alt="IHG"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-8"
        src="../../../images/index/employers/home/icici.png"
        alt="ICICI Bank"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-9"
        src="../../../images/index/employers/home/honda.png"
        alt="Honda"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-10"
        src="../../../images/index/employers/home/samsung.png"
        alt="Samsung"
        className={styles.employersImage}
        {...commonImageProps}
      />,

      <StaticImage
        key="emp-first-11"
        src="../../../images/index/employers/home/L&T_Construction.png"
        alt="L&T Constructions"
        className={styles.employersImage}
        {...commonImageProps}
      />,

      <StaticImage
        key="emp-first-12"
        src="../../../images/index/employers/home/Westside.png"
        alt="Westside"
        className={styles.employersImage}
        {...commonImageProps}
      />,
    ],
    right: [
      <StaticImage
        key="emp-first-14"
        src="../../../images/index/employers/home/Reliance.png"
        alt="Reliance"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-15"
        src="../../../images/index/employers/home/HDFC.png"
        alt="HDFC"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-16"
        src="../../../images/index/employers/home/Vodafone.png"
        alt="Vodafone"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-17"
        src="../../../images/index/employers/home/axis.png"
        alt="Axis Bank"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-18"
        src="../../../images/index/employers/home/Tata_Motors.png"
        alt="Tata Motors"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-19"
        src="../../../images/index/employers/home/reliance_capital.png"
        alt="Reliance Capital"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-20"
        src="../../../images/index/employers/home/Paytm.png"
        alt="PAYTM"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-21"
        src="../../../images/index/employers/home/radisson.png"
        alt="Radisson Hotel Group"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-22"
        src="../../../images/index/employers/home/oberoi.png"
        alt="Oberoi Hotels"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-23"
        src="../../../images/index/employers/home/mahindra.png"
        alt="Mahindra Hotels"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-24"
        src="../../../images/index/employers/home/tata_capital.png"
        alt="TATA Capital"
        className={styles.employersImage}
        {...commonImageProps}
      />,
      <StaticImage
        key="emp-first-25"
        src="../../../images/index/employers/home/idfc.png"
        alt="IDFC Bank"
        className={styles.employersImage}
        {...commonImageProps}
      />,
    ],
  }
  // const bfsi = [
  //   "State Bank of India",
  //   "ICICI Bank",
  //   "AXIS Bank",
  //   "IDFC Bank",
  //   "Canara Bank",
  //   "Reliance Capital",
  //   "Adventity Global Services",
  //   "TATA BFS",
  //   "DHFL",
  //   "Dynamic Financial Services",
  //   "AEON Credit Service",
  //   "VGM Consultants",
  //   "Concentrix",
  //   "Karvy",
  //   "PAMAC",
  //   "PAYTM",
  //   "Baroda Global Services",
  //   "TATA Capital",
  //   "Teleperformance",
  // ]
  // const hospitality = [
  //   "Ginger Hotel",
  //   "Peerless Inn",
  //   "The Fern",
  //   "Holiday Inn",
  //   "Hotel Hindustan International",
  //   "Udaan Hotels & Resorts",
  //   "Clarks Inn",
  //   "ITC Fortune",
  //   "Zing Restaurant",
  //   "Eagleton",
  //   "Barbeque Nation",
  //   "Leela Palace",
  //   "Nando’s",
  //   "Ahuja Residency",
  //   "Radisson Hotel Group",
  //   "Deltin Casino",
  //   "Oberoi Hotels",
  //   "Mahindra Hotels",
  //   "TGI Hotels",
  //   "Marriott"
  // ]
  // const healthcare = [
  //   "Max Healthcare, Delhi ",
  //   "Batra Hospital, Delhi ",
  //   "Indian Spinal Injuries Centre, Delhi ",
  //   "Sarvodaya Hospital, Faridabad ",
  //   "Fortis, Delhi ",
  //   "Sunrise Hospital, Cochin ",
  //   "Nemcare Hospital, Guwahati ",
  //   "Pulse Hospital, Trivandrum ",
  //   "GM Nurses Centre, Kolkata ",
  //   "Healthcare at Home ",
  //   "Sodexo Mahabir Hospital, Surat ",
  //   "Divine Hospital, Kolkata ",
  // ]
  // const ites = [
  //   "Ienergizer IT Services Pvt limited",
  //   "Sandha & Company",
  //   "APEX SOLUTIONS LTD",
  //   "Nakshtra Agro Foods Pvt. Ltd.",
  //   "BB Softech Pvt Ltd",
  //   "VGM Consultants Pvt. Ltd.",
  //   "RedStone",
  //   "Techserve Solutions",
  //   "Narayanamma Associates LLP",
  // ]
  // const engineering = [
  //   "Vm Force Services",
  //   "Shri Krupa Services Pvt Ltd",
  //   "Universal Facility Management Services",
  //   "Tata Autocomp",
  //   "Mahindra & Mahindra ",
  //   "KSB Pvt. Ltd.",
  //   "Patri Engineering",
  //   "Distil",
  //   "Jai Bhavani Mata Engineering Pvt Ltd",
  //   "Exponential Engineering Pvt Ltd",
  //   "Inara Neem Faciliator",
  //   "Lava International Ltd",
  //   "Zet Town",
  //   "OEL Electronics Pvt Ltd.",
  //   "Rane Industries",
  //   "JBM Auto Ltd.",
  //   "Volvo Eicher",
  //   "RPS Group of Industries",
  //   "Cosmos Manpower Pvt. Ltd.",
  //   "Adequate Management Pvt. Ltd.",
  // ]
  // const apparel = [
  //   "Marg By Soumitra",
  //   "Garima Boutique",
  //   "Anjali Creation",
  //   "Babui",
  //   "Radhika Boutique",
  //   "Shreya Garments ",
  //   "Manisha Hosiery",
  //   "PeeEmpro",
  //   "Orient Fashion",
  //   "Smriti Creation Handmade Work",
  //   "Akriti Apparels Pvt. Ltd.",
  //   "TCNS Clothing Company Ltd.",
  //   "Sahu Global Private Ltd.",
  // ]
  // const employers = [
  //   ...bfsi,
  //   ...hospitality,
  //   ...healthcare,
  //   ...ites,
  //   ...engineering,
  //   ...apparel
  // ];
  // function splitArray(arr) {
  //   if (arr.length === 0) return [];

  //   const mid = Math.ceil(arr.length / 2);
  //   return [arr.slice(0, mid), arr.slice(mid)];
  // }

  // const splittedArray = splitArray(employers);
  // const leftArr = splittedArray[0] || [];
  // const rightArr = splittedArray[1] || [];
  // const employersImages = {
  //   left: leftArr.map((val)=>(
  //     <div className="border border-[#4559ED] bg-[#F0F8FF] rounded-lg p-3 min-h-[100px] w-[230px] flex items-center justify-center" key={val}>
  //       <BodyText variant="bodyText7" className="text-center font-bold">{val}</BodyText>
  //     </div>
  //   )),
  //   right: rightArr.map((val)=>(
  //     <div className="border border-[#F8C807] bg-[#F8EEC8] rounded-lg p-3 min-h-[100px] w-[230px] flex items-center justify-center" key={val}>
  //       <BodyText variant="bodyText7" className="text-center font-bold">{val}</BodyText>
  //     </div>
  //   )),
  // }

  return (
    <>
      <HeadingCover className="text-center mb-2 mx-auto">
        <span>1000+</span> Employers
      </HeadingCover>
      <MovingImages images={employersImages} />
      <div className="text-center mt-6 mx-auto">
        <Button
          className="mb-0"
          onClick={() => {
            setIsRegistrationFormOpen(true)
          }}
        >
          Register Now
        </Button>
      </div>
      <RegistrationForm
        isOpen={isRegistrationFormOpen}
        setIsOpen={setIsRegistrationFormOpen}
        clickedFrom={"Home-Employers"}
      />
    </>
  )
}
